/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetErrorMessages200ResponseInner
 */
export interface GetErrorMessages200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetErrorMessages200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorMessages200ResponseInner
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof GetErrorMessages200ResponseInner
     */
    description: string;
}

/**
 * Check if a given object implements the GetErrorMessages200ResponseInner interface.
 */
export function instanceOfGetErrorMessages200ResponseInner(value: object): value is GetErrorMessages200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function GetErrorMessages200ResponseInnerFromJSON(json: any): GetErrorMessages200ResponseInner {
    return GetErrorMessages200ResponseInnerFromJSONTyped(json, false);
}

export function GetErrorMessages200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetErrorMessages200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'description': json['description'],
    };
}

export function GetErrorMessages200ResponseInnerToJSON(json: any): GetErrorMessages200ResponseInner {
    return GetErrorMessages200ResponseInnerToJSONTyped(json, false);
}

export function GetErrorMessages200ResponseInnerToJSONTyped(value?: GetErrorMessages200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
    };
}

